import React from 'react';

import VStack from './vstack';

export default React.memo(VStack);
